import React from 'react';
import { Col, Row, Card, Button } from 'antd';
import { HomeTwoTone, ShoppingTwoTone } from '@ant-design/icons';
const HomeAddressTitle = () => {
  return (
    <>
      <HomeTwoTone /> Home
    </>
  );
};

const WorkTitle = () => {
  return (
    <>
      <ShoppingTwoTone /> Work
    </>
  );
};

const addressText =
  'HN 232SDS, JACK STREET, MARKET TO-TO, NEAR GYM HN 232SDS, JACK STREET, MARKET TO-TO, NEAR GYM HN 232SDS, JACK STREET, MARKET TO-TO, NEAR GYM';
const DeliveryAddressDescription = () => {
  return (
    <Row style={{ padding: 15 }} gutter={[16, 16]}>
      <Col xs={24} sm={11} md={11} lg={11} xl={11} xxl={11}>
        <Card
          title={<HomeAddressTitle />}
          extra={<Button className="btn-green">Select</Button>}
        >
          {addressText}
        </Card>
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 11, offset: 1 }}
        md={{ span: 11, offset: 1 }}
        lg={{ span: 11, offset: 1 }}
        xl={{ span: 11, offset: 1 }}
        xxl={{ span: 11, offset: 1 }}
      >
        <Card
          title={<WorkTitle />}
          extra={<Button className="btn-green">Select</Button>}
        >
          {addressText}
        </Card>
      </Col>
    </Row>
  );
};

export default DeliveryAddressDescription;
